var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFieldmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    viewBox: "0 0 142 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 46,
    rx: 8.5,
    fill: "#313344",
    stroke: "url(#paint0_linear_621_1823)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.766 23.4246C135.584 23.7544 135.32 24.0318 134.999 24.2297C134.679 24.4277 134.312 24.5396 133.936 24.5546L131.436 23.7846L132.896 28.0546C132.982 28.5063 132.944 28.9728 132.786 29.4046C132.669 29.6224 132.539 29.8328 132.396 30.0346C131.716 30.6646 130.506 30.1946 129.846 29.8646L123.146 25.3246L126.866 33.5146C127.186 35.2046 125.696 36.3746 124.986 36.8146C121.512 38.5547 117.7 39.517 113.816 39.6346C97.7559 40.5046 81.7159 41.6346 65.6659 42.6346C53.4259 42.5846 41.5559 40.5046 29.6659 38.8146C24.5659 38.0846 19.3559 37.9146 14.2059 37.4246C9.72589 36.9946 6.82589 34.8646 5.87589 31.2746C5.02085 28.4604 4.78816 25.494 5.19395 22.5809C5.59974 19.6679 6.6343 16.8779 8.22589 14.4046C8.72231 13.9387 9.32668 13.6034 9.98471 13.4289C10.6427 13.2543 11.3338 13.246 11.9959 13.4046L20.6059 16.8946L16.3259 8.78459C16.145 8.31887 16.1547 7.80062 16.3531 7.34207C16.5515 6.88352 16.9226 6.52156 17.3859 6.33459C18.2659 5.99459 19.1659 5.67459 20.0259 5.33459C21.108 4.91857 22.2621 4.722 23.421 4.75634C24.5798 4.79067 25.7203 5.05522 26.7759 5.53459C29.3429 6.6726 32.2211 6.90187 34.9359 6.18459C36.317 5.89954 37.726 5.77205 39.1359 5.80459C45.4559 5.80459 51.7759 5.80459 58.1359 5.80459C70.4559 5.80459 82.8059 6.27459 95.0759 4.66459C99.9966 4.016 105.001 4.54729 109.676 6.21459C112.826 7.33459 115.866 6.72459 118.936 6.02459C121.616 5.40459 124.266 4.66459 126.936 4.21459C131.306 3.48459 133.576 4.58459 135.256 8.01459C137.816 13.2346 137.606 18.3646 135.766 23.4246Z",
    fill: "#3D4055"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_1823",
    x1: 71,
    y1: 1,
    x2: 71,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5067",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldmedium);
export default __webpack_public_path__ + "static/media/fieldmedium.ef282561e0a75174b482e7b77f570971.svg";
export { ForwardRef as ReactComponent };